var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('organization-details-menu',{on:{"refresh":_vm.getCurrentOrganization}}),_c('organization-form',{attrs:{"loading":_vm.loading,"organization":_vm.organization},on:{"submit":_vm.updateOrganization}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }